import React, {useEffect, useRef, useState} from "react";

import {Button as RB, Col, Form, Modal, Row} from "react-bootstrap";
import {ReportScheduleService} from "./ReportScheduleService";
import 'react-dropdown/style.css';
import "react-table/react-table.css";
import Dropdown from 'react-dropdown'
import micro_reporter_api from "../../apis/micro-reporter-api";
import {Button} from "primereact/button";
import {Toast} from "primereact/toast";
import SideNavigation from "../SideNavigation";
import NavigationBar from "../NavigationBar";
import {Badge} from "@mui/material";
import ReactTable from "react-table";


const ReportSchedule = () => {

    const [reportSchedules, setReportSchedules] = useState([]);
    const [pageNumber, setPageNumber] = useState();

    let userId = JSON.parse(localStorage.getItem("user")).id;


    const [currentReport, setCurrentReport] = useState();

    const toast = useRef(null);
    let reportId = new URLSearchParams(window.location.search).get("reportId");
    const days =
        ["MONDAY", "TUESDAY", "WEDNESDAY", "THURSDAY", "FRIDAY", "SATURDAY", "SUNDAY"];
    const numberDays = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23",
        "24", "25", "26", "27", "28", "29", "30", "Last Day Of Month"]
    const reportScheduleService = new ReportScheduleService();
    const [createSchedule, setCreateSchedule] = useState({
        cronJob: {
            cronTimeType: null,
            timeFormat: null,
            dayOfWeek: null,
            dayOfMonth: null
        },
        userId: userId,
        reportId: parseInt(reportId),
        active: true

    });
    const [createShow, setCreateShow] = useState(false);
    const handleCreateClose = () => {
        setCreateSchedule({...createSchedule, enable: false, cronJob: {cronTimeType: null}});

        setTimeout(() => {
            setCreateShow(false);
        }, 200)
    }
    const handleCreateShow = () => {
        setTimeout(() => {
            setCreateShow(true);
        }, 200)
    }
    const [deleteScheduleShow, setDeleteScheduleShow] = useState(false);
    const handleDeleteClose = () => {
        setEditSchedule(null);
        setTimeout(() => {
            setDeleteScheduleShow(false);
        }, 200)
    }
    const [editSchedule, setEditSchedule] = useState();
    const [reportList, setReportList] = useState([]);
    const [editScheduleShow, setEditScheduleShow] = useState(false);
    const handleEditClose = () => {

        getReportSchedules();
        setTimeout(() => {
            setEditScheduleShow(false);
        }, 215)
    }

    useEffect(() => {
        getReportSchedules();
        getReportList();
        getReportById();
    }, []);

    const getReportById = () => {
        if (reportId) {
            reportScheduleService.getReportById(reportId).then(res => {
                setCurrentReport(res)

            }).catch()
        }


    }

    const getReportList = () => {
        (async () => {
            try {

                await micro_reporter_api.get(`/micro-reporter/report/all-by-user-id?id=${userId}`).then(
                    (response) => {
                        setReportList(response.data);

                    }
                )
            } catch (e) {

            }
        })();

    }
    const getReportSchedules = () => {
        try {
            if (reportId) {
                (async () => {


                    await micro_reporter_api.get(`/micro-reporter/schedule?reportId=${reportId}&userId=${userId}`).then(res => {
                            setReportSchedules(res.data)

                        }
                    )
                })();
            } else {
                (async () => {
                    await micro_reporter_api.get(`/micro-reporter/schedule/user?userId=${userId}`).then(res => {
                            setReportSchedules(res.data)

                        }
                    )
                })();
            }

        } catch (err) {

        }


    }

    const editScheduleDialog = (rowData) => {
        let _rowData = {...rowData};
        if (_rowData.cronJob.cronTimeType === "MONTLY") {
            _rowData.cronJob.dayOfMonthLabel = _rowData.cronJob.dayOfMonth.toString();
        }
        const _hour = _rowData.cronJob.time[0] < 10 ? "0" + _rowData.cronJob.time[0] : _rowData.cronJob.time[0];
        const _minute = _rowData.cronJob.time[1] < 10 ? "0" + _rowData.cronJob.time[1] : _rowData.cronJob.time[1];

        _rowData.cronJob.timeFormat = `${_hour}:${_minute}`


        _rowData.reportId = _rowData?.report?.id
        _rowData.userId = _rowData?.user?.id
        _rowData.reportName = _rowData?.report?.name;

        setEditSchedule({..._rowData})


        setTimeout(() => {
            setEditScheduleShow(true)
        }, 250);

    }

    const renderReportName = (cellInfo) => {
        const data = reportSchedules[cellInfo.index];
        return (
            <div className="name-fav-wrapper">
                <div className="name-fav-wrapper__item-name">
                    <div
                        className="editable-name-div none"
                        contentEditable
                        id={cellInfo.original.id}
                        suppressContentEditableWarning

                    />
                    {data["report"].name}
                </div>
            </div>
        );
    };

    // const renderSchedulerName = (cellInfo) => {
    //     const data = reportSchedules[cellInfo.index];
    //     return (
    //         <div className="name-fav-wrapper">
    //             <div className="name-fav-wrapper__item-name">
    //                 <div
    //                     className="editable-name-div none"
    //                     contentEditable
    //                     id={cellInfo.original.id}
    //                     suppressContentEditableWarning
    //
    //                 />
    //                 {data["name"]}
    //             </div>
    //         </div>
    //     );
    // };

    const renderExecutionDay = (cellInfo) => {
        const data = reportSchedules[cellInfo.index];
        return (
            <div className="name-fav-wrapper">
                <div className="name-fav-wrapper__item-name">
                    <div
                        className="editable-name-div none"
                        contentEditable
                        id={cellInfo.original.id}
                        suppressContentEditableWarning

                    />
                    {data["cronJob"]?.cronTimeType === "MONTLY" && data["cronJob"]?.dayOfMonth === 0 ? "LAST DAY OF MONTH" : data["cronJob"]?.cronTimeType === "MONTLY" ? data["cronJob"]?.dayOfMonth + ". DAY OF MONTH" : data["cronJob"]?.cronTimeType === "WEEKLY" ? data["cronJob"]?.dayOfWeek : "EVERY DAY"}
                </div>
            </div>
        );
    };

    const renderTimeType = (cellInfo) => {
        const data = reportSchedules[cellInfo.index];
        return (
            <div className="name-fav-wrapper">
                <div className="name-fav-wrapper__item-name">
                    <div
                        className="editable-name-div none"
                        contentEditable
                        id={cellInfo.original.id}
                        suppressContentEditableWarning

                    />
                    {data["cronJob"].cronTimeType}
                </div>
            </div>
        );
    };

    const renderCronTime = (cellInfo) => {
        const data = reportSchedules[cellInfo.index];
        return (
            <div className="name-fav-wrapper">
                <div className="name-fav-wrapper__item-name">
                    <div
                        className="editable-name-div none"
                        contentEditable
                        id={cellInfo.original.id}
                        suppressContentEditableWarning

                    />
                    {data["cronJob"].time[0] < 10 ? "0" + data["cronJob"].time[0] : data["cronJob"].time[0]}:{data["cronJob"].time[1] < 10 ? "0" + data["cronJob"].time[1] : data["cronJob"].time[1]}
                </div>
            </div>
        );
    };


    const renderEnable = (cellInfo) => {
        const data = reportSchedules[cellInfo.index];
        return (
            <div className="name-fav-wrapper">
                <div className="name-fav-wrapper__item-name">
                    <div
                        className="editable-name-div none"
                        contentEditable
                        id={cellInfo.original.id}
                        suppressContentEditableWarning

                    />
                    {data["active"] ? <Badge style={{paddingLeft: 20}} badgeContent={"Active"} color="success"/>
                        : <Badge style={{paddingLeft: 20}} badgeContent={"Inactive"} color="error"/>}
                </div>
            </div>
        );
    };

    const renderActions = (cellInfo) => {
        const data = reportSchedules[cellInfo.index];
        return (
            <div style={{color: "#000000"}}>
                <a className="fa fa-pencil"
                   onClick={() => editScheduleDialog(data)} style={{width: "30px", height: "20px", color: "#0C5DB6"}}/>
                <a className="fa fa-trash" style={{width: "30px", height: "20px", color: "#0C5DB6"}}
                   onClick={e => {
                       setEditSchedule(data)
                       setTimeout(() => {
                           setDeleteScheduleShow(true)

                       }, 250)

                   }}/>
            </div>
        );
    };

    const renderTable = () => {
        if (reportSchedules.length > 0) {
            return (
                <div>
                    <div id="table-panel">
                        <div className="table-list layout-option-content show" data-layout="list">
                            <div className="sub-list show"
                            >
                                <ReactTable
                                    data={reportSchedules}
                                    filterable
                                    defaultFilterMethod={(filter, row) =>
                                        String(row[filter.accessor]) === filter.value}
                                    previousText='Previous'
                                    nextText='Next'
                                    pageText='Page'
                                    rowsText='Rows'
                                    noDataText='No Rows Found'
                                    loadingText='Loading'
                                    defaultFilterMethod={(filter, row) =>
                                        String(row[filter.id]) === filter.value}
                                    onPageChange={(data) => {
                                        setPageNumber(data)
                                    }}
                                    page={pageNumber ? pageNumber : undefined}

                                    const columns={[
                                    {
                                        columns: [
                                            {
                                                Header: () => (
                                                    <div className="title-search-wrap">
                                                        <span>Report Name</span>
                                                    </div>
                                                ),
                                                accessor: "report-name",
                                                Cell: renderReportName,
                                                className: "scheduler-report-name-column",
                                                sortable: false,
                                                filterable: false,
                                            }]
                                    },
                                    {
                                        columns: [
                                            {
                                                Header: 'Execution Day',
                                                accessor: "execution-day",
                                                Cell: renderExecutionDay,
                                                className: "scheduler-execution-day-column",
                                                sortable: false,
                                                filterable: false,
                                            }]
                                    },
                                    {
                                        columns: [
                                            {
                                                Header: 'Recurrence',
                                                accessor: "time-type",
                                                Cell: renderTimeType,
                                                className: "scheduler-time-type-column",
                                                sortable: false,
                                                filterable: false,
                                            }]
                                    },
                                    {
                                        columns: [
                                            {
                                                Header: 'Execution Time',
                                                accessor: "cron-time",
                                                Cell: renderCronTime,
                                                className: "scheduler-cron-time-column",
                                                sortable: false,
                                                filterable: false,
                                            }]
                                    },
                                    {
                                        columns: [
                                            {
                                                Header: 'Active / Inactive',
                                                accessor: "scheduler-enabled",
                                                Cell: renderEnable,
                                                className: "scheduler-enable-column",
                                                sortable: false,
                                                filterable: false,
                                            }]
                                    },
                                    {
                                        columns: [
                                            {
                                                Header: 'Actions',
                                                Cell: renderActions,
                                                className: "scheduler-action-column",
                                                sortable: false,
                                                filterable: false,
                                            }]
                                    }
                                ]}
                                    defaultPageSize={10}
                                    className="-striped -highlight"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
    };

    const handleError = (err) => {

        return toast.current.show({
            severity: 'error',
            summary: "Required field cannot empty"

        })

    };

    return (
        <div>
            <SideNavigation current="schedule"/>
            <div className="page-order">
                <NavigationBar/>
                <Toast ref={toast}/>
                <div id="connection-form-panel">
                    <div style={{marginBottom: "35px", width: "100%"}}>
                        <h5 className="page-title">Scheduled Reports</h5>
                        <RB variant="primary" onClick={handleCreateShow} id="report-add-button">
                            Create
                        </RB>
                    </div>
                    {renderTable()}
                </div>

                <Modal centered size="lg" show={createShow} onHide={handleCreateClose}>
                    <Modal.Header closeButton>
                        <Modal.Title>Create Scheduler</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form>


                            <Form.Group as={Row} className="mb-5" controlId="reportName">

                                <Form.Label column sm={4}>
                                    Report Name
                                </Form.Label>
                                <Col sm={6}>
                                    {reportId ? <div>
                                            <Dropdown options={reportList.map(value => {
                                                return value.name
                                            })}
                                                      disabled
                                                      value={currentReport?.name}
                                                      onChange={e => {

                                                      }
                                                      }

                                                      placeholder="Select Report Name"/>

                                        </div> :

                                        <div>
                                            <Dropdown options={reportList.map(value => {
                                                return value.name
                                            })}
                                                      onChange={e => {
                                                          let _selected = reportList.find(value => value.name === e.value);
                                                          let _createdSchedule = {...createSchedule};
                                                          _createdSchedule.reportId = _selected?.id;
                                                          setCreateSchedule(_createdSchedule)
                                                      }
                                                      }

                                                      placeholder="Select a report"/>

                                        </div>
                                    }
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} className="mb-4" controlId="formHorizontalEnable">
                                <Form.Label column sm={4}>
                                    Active
                                </Form.Label>
                                <Col sm={8}>
                                    <Form.Check required style={{paddingTop: 7}}
                                                name="formHorizontalEnable"
                                                onChange={e => {
                                                    let _createSchedule = {...createSchedule};
                                                    _createSchedule.active = e.target.checked;
                                                    setCreateSchedule(_createSchedule)

                                                }}
                                                checked={createSchedule.active}
                                                type="checkbox" placeholder="Enable"/>
                                </Col>
                            </Form.Group>


                            <fieldset>
                                <Form.Group as={Row} className="mb-4">
                                    <Form.Label as="legend" column sm={4}>
                                        Recurrence
                                    </Form.Label>
                                    <Col sm={8}>
                                        <Form.Check
                                            type="radio"
                                            label="Montly"
                                            name="formHorizontalRadios"
                                            id="formHorizontalRadios1"
                                            onClick={e => {
                                                let _createSchedule = {...createSchedule};
                                                _createSchedule.cronJob.cronTimeType = "MONTLY";
                                                setCreateSchedule(_createSchedule)
                                            }}
                                        />
                                        <Form.Check
                                            type="radio"
                                            label="Weekly"
                                            name="formHorizontalRadios"
                                            id="formHorizontalRadios2"
                                            onClick={e => {
                                                let _createSchedule = {...createSchedule};
                                                _createSchedule.cronJob.cronTimeType = "WEEKLY";
                                                setCreateSchedule(_createSchedule)
                                            }}
                                        />
                                        <Form.Check
                                            type="radio"
                                            label="Daily"
                                            name="formHorizontalRadios"
                                            id="formHorizontalRadios3"
                                            onClick={e => {
                                                let _createSchedule = {...createSchedule};
                                                _createSchedule.cronJob.cronTimeType = "DAILY";
                                                setCreateSchedule(_createSchedule)
                                            }}
                                        />
                                    </Col>
                                </Form.Group>

                                <Form.Group as={Row} className="mb-4" controlId="formHorizontalCheck">


                                    <Col sm={{span: 6, offset: 4}}>
                                        {createSchedule?.cronJob?.cronTimeType === "WEEKLY" ?

                                            <Dropdown options={days}
                                                      onChange={e => {
                                                          let _createSchedule = {...createSchedule}
                                                          _createSchedule.cronJob.dayOfMonth = null;
                                                          _createSchedule.cronJob.dayOfMonthLabel = null;
                                                          _createSchedule.cronJob.dayOfWeek = e.value
                                                          setCreateSchedule(_createSchedule)
                                                      }}
                                                      value={createSchedule.cronJob?.dayOfWeek}
                                                      placeholder="Select a day"/>


                                            : createSchedule?.cronJob?.cronTimeType === "MONTLY" ?
                                                <div>
                                                    <Dropdown options={numberDays}
                                                              onChange={e => {
                                                                  let _createSchedule = {...createSchedule}
                                                                  _createSchedule.cronJob.dayOfWeek = null;
                                                                  if (e.value === "Last Day Of Month") {
                                                                      _createSchedule.cronJob.dayOfMonth = 0;
                                                                      _createSchedule.cronJob.dayOfMonthLabel = "Last Day Of Month";
                                                                  } else {
                                                                      _createSchedule.cronJob.dayOfMonth = parseInt(e.value)
                                                                      _createSchedule.cronJob.dayOfMonthLabel = e.value

                                                                  }
                                                                  setCreateSchedule(_createSchedule)
                                                              }}
                                                              value={createSchedule?.cronJob?.dayOfMonthLabel}
                                                    />
                                                </div>

                                                : ""}
                                    </Col>
                                </Form.Group>
                            </fieldset>

                            <Form.Group as={Row} className="mb-4" controlId="formHorizontalCheck">
                                <Form.Label>
                                    <Col sm={{span: 4, offset: 0}}>
                                        Time</Col>
                                </Form.Label>
                                <Col sm={{span: 8, offset: 3}}>
                                    <input value={createSchedule?.cronJob?.timeFormat} type="time" onChange={e => {
                                        let _createSchedule = {...createSchedule};
                                        _createSchedule.cronJob.timeFormat = e.target.value;
                                        setCreateSchedule(_createSchedule)
                                    }}/>
                                </Col>
                            </Form.Group>


                        </Form>

                    </Modal.Body>
                    <Modal.Footer>
                        <Button style={{backgroundColor: "#0069d9", width: "100px", height: "40px"}} label="Save"
                                className="p-button-raised p-button-primary" onClick={e => {
                            reportScheduleService.createReportSchedule(createSchedule).then(res => {
                                toast.current.show({
                                    severity: 'success',
                                    summary: 'Successful Transaction',
                                    detail: 'Report Schedule Created.'
                                });
                                setCreateSchedule({
                                    cronJob: {
                                        cronTimeType: null,
                                        timeFormat: null,
                                        dayOfWeek: null,
                                        dayOfMonth: null
                                    },
                                    userId: userId,
                                    reportId: parseInt(reportId),
                                    active: true

                                })
                                setCreateShow(false);
                                getReportSchedules();
                            }).catch(err => handleError(err))
                        }}/>
                            </Modal.Footer>
                            </Modal>

                            <Modal centered size="lg" show={editScheduleShow}
                            onHide={handleEditClose}>
                            <Modal.Header closeButton>
                            <Modal.Title>Schedule Update</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                            <Form>

                            <Form.Group as={Row} className="mb-4" controlId="reportName">

                            <Form.Label column sm={4}>
                            Report Name
                            </Form.Label>
                            <Col sm={6}>
                        {reportId ? <div>
                            <Dropdown options={reportList.map(value => {
                            return value.name
                        })}
                            disabled
                            value={currentReport?.name}
                            onChange={e => {

                        }
                        }

                            placeholder="Select a day"/>

                            </div> :

                            <Dropdown options={reportList.map(value => {
                            return value.name
                        })}
                            onChange={e => {
                            let _selected = reportList.find(value => value.name === e.value);
                            let _editSchedule = {...editSchedule};
                            _editSchedule.reportId = _selected?.id;
                            _editSchedule.reportName = e.value
                            setEditSchedule(_editSchedule)
                        }}
                            value={editSchedule?.reportName}

                            placeholder="Select a report"/>

                        }

                            </Col>
                            </Form.Group>
                            <Form.Group as={Row} className="mb-4" controlId="formHorizontalEnable">
                            <Form.Label as="legend" column sm={4}>
                            Enable
                            </Form.Label>
                            <Col sm={8}>
                            <Form.Check required style={{paddingTop: 7}}
                            name="formHorizontalEnable"
                            checked={editSchedule?.active}
                            onChange={e => {
                            let _editSchedule = {...editSchedule};
                            _editSchedule.active = e.target.checked;
                            setEditSchedule(_editSchedule)
                        }}

                            type="checkbox" placeholder="Enable"/>
                            </Col>
                            </Form.Group>


                            <Form.Group as={Row} className="mb-4">
                            <Form.Label as="legend" column sm={4}>
                            Recurrence
                            </Form.Label>
                            <Col sm={8}>
                            <Form.Check
                            type="radio"
                            label="Montly"

                            checked={editSchedule?.cronJob.cronTimeType === "MONTLY"}
                            onClick={e => {
                            let _editSchedule = {...editSchedule};
                            _editSchedule.cronJob.cronTimeType = "MONTLY";
                            setEditSchedule(_editSchedule)
                        }}
                            />
                            <Form.Check
                            type="radio"
                            label="Weekly"
                            id="weekly"

                            checked={editSchedule?.cronJob.cronTimeType === "WEEKLY"}
                            onClick={e => {
                            let _editSchedule = {...editSchedule};
                            _editSchedule.cronJob.cronTimeType = "WEEKLY";
                            setEditSchedule(_editSchedule)
                        }}
                            />
                            <Form.Check
                            type="radio"
                            label="Daily"
                            checked={editSchedule?.cronJob.cronTimeType === "DAILY"}
                            id="daily"
                            onClick={e => {
                            let _editSchedule = {...editSchedule};
                            _editSchedule.cronJob.cronTimeType = "DAILY";
                            setEditSchedule(_editSchedule)
                        }}

                            />
                            </Col>
                            </Form.Group>

                            <Form.Group as={Row} className="mb-4" controlId="formHorizontalCheck">


                            <Col sm={{span: 6, offset: 4}}>
                        {editSchedule?.cronJob?.cronTimeType === "WEEKLY" ?

                            <Dropdown options={days}
                            onChange={e => {
                            let _editSchedule = {...editSchedule}
                            _editSchedule.cronJob.dayOfMonth = null;
                            _editSchedule.cronJob.dayOfWeek = e.value
                            setEditSchedule(_editSchedule)
                        }}
                            value={editSchedule?.cronJob?.dayOfWeek}
                            placeholder="Select a day"/>


                            : editSchedule?.cronJob?.cronTimeType === "MONTLY" ?
                            <div>
                            <Dropdown options={numberDays}
                            onChange={e => {
                            let _editSchedule = {...editSchedule}
                            _editSchedule.cronJob.dayOfWeek = null;
                            if (e.value === "Last Day Of Month") {
                            _editSchedule.cronJob.dayOfMonth = 0;
                            _editSchedule.cronJob.dayOfMonthLabel = "Last Day Of Month";
                        } else {
                            _editSchedule.cronJob.dayOfMonth = parseInt(e.value)
                            _editSchedule.cronJob.dayOfMonthLabel = e.value

                        }
                            setEditSchedule(_editSchedule)
                        }}
                            value={editSchedule?.cronJob?.dayOfMonthLabel}
                            />
                            </div>

                            : ""}
                            </Col>
                            </Form.Group>

                            <Form.Group as={Row} className="mb-4" controlId="formHorizontalCheck">
                            <Form.Label>
                            <Col sm={{span: 4, offset: 0}}>
                            Time</Col>
                            </Form.Label>
                            <Col sm={{span: 8, offset: 3}}>
                            <input value={editSchedule?.cronJob?.timeFormat} type="time" onChange={e => {
                            let _editSchedule = {...editSchedule};
                            _editSchedule.cronJob.timeFormat = e.target.value;
                            setEditSchedule(_editSchedule)
                        }}/>
                            </Col>
                            </Form.Group>


                            </Form>
                            </Modal.Body>

                            <Modal.Footer>
                            <Button style={{backgroundColor: "#0069d9", width: "100px", height: "40px"}} label="Update" className="p-button-raised p-button-primary" onClick={e => {
                            reportScheduleService.updateReportSchedule(editSchedule).then(res => {
                            toast.current.show({
                            severity: 'success',
                            summary: 'Successful Transaction',
                            detail: 'Report Schedule Updated.'
                        });
                            setEditScheduleShow(false);
                            getReportSchedules();
                        }).catch(err => {
                            toast.current.show({
                            severity: 'error',
                            summary: err

                        });
                        });
                        }}/>

                            </Modal.Footer>
                            </Modal>


                            <Modal centered size="lg"  show={deleteScheduleShow} onHide={handleDeleteClose}>
                            <Modal.Header closeButton>
                            <Modal.Title>Delete scheduler</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                            Are you sure delete this scheduler ?
                            </Modal.Body>
                            <Modal.Footer>
                            <Button style={{backgroundColor: "#ff0000", width: "100px", height: "40px"}} label="Delete" className="p-button-raised p-button-danger" onClick={e => {
                            reportScheduleService.deleteReportSchedule(editSchedule?.id).then(res => {
                            toast.current.show({
                            severity: 'success',
                            summary: 'Successful Transaction',
                            detail: 'Report Schedule Deleted.'
                        });
                            setDeleteScheduleShow(false);
                            getReportSchedules();
                        }).catch(err => {})
                        }}/>
                            </Modal.Footer>
                            </Modal>
                            </div>

                            </div>
                            )
                            }
                            export default ReportSchedule
